import React, { useState, useEffect } from 'react';
import api from '../api';

const TrialBalance = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const load = (params = {}) => {
    setLoading(true);
    setError('');
    api.get('/trial-balance/', { params })
      .then(res => setRows(Array.isArray(res.data) ? res.data : []))
      .catch(() => setError('Failed to load trial balance'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleFilter = (e) => {
    e.preventDefault();
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    load(params);
  };

  return (
    <div>
      <div className="flex-between">
        <h2>Trial Balance</h2>
      </div>
      <form onSubmit={handleFilter} style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>Start Date</label>
          <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
        </div>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>End Date</label>
          <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
        </div>
        <button type="submit" className="btn btn-primary">Apply</button>
        <button type="button" className="btn btn-outline" onClick={() => { setStartDate(''); setEndDate(''); load(); }}>Clear</button>
      </form>
      {error && <div className="error">{error}</div>}
      {loading ? <div>Loading...</div> : (
        <table className="table">
          <thead>
            <tr>
              <th>Account Code</th>
              <th>Account Name</th>
              <th>Type</th>
              <th>Debit</th>
              <th>Credit</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.account_code}-${i}`}>
                <td>{r.account_code}</td>
                <td>{r.account_name}</td>
                <td>{r.account_type}</td>
                <td>{Number(r.debit).toFixed(2)}</td>
                <td>{Number(r.credit).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TrialBalance;
